<!-- Outside the container, so the header spans the full width; the back button and title stay in the container -->
<div class="crud-header">
    <div class="ticket-header-logo">
        <img src="assets/logo/logo.svg" alt="TSNed">
    </div>
    <div class="container">
        <div class="row">
            <div class="col d-flex align-items-center gap-2 gap-sm-3">
                <div [routerLink]="['/', Routenames.TtmTickets]" class="controls-left-button" matTooltip="Terug naar tickets" matTooltipPosition="after">
                    <i class="fa fa-arrow-left-from-arc"></i>
                </div>
                <h1 class="mt-2">TVM-tickets</h1>
            </div>
        </div>
    </div>
</div>

<div class="container mt-3">

    @if(ttmTicket(); as ticket) {
    <section class="detail-card">
        <header class="card-header">
            <h2 class="card-title">Ticket #{{ ticket.id }} - {{ ticket.type | TtmTicketType }}</h2>
            <div class="card-actions">
                <span class="department-chip">{{ ticket.department | TtmTicketDepartment }}</span>
                <button mat-icon-button type="button"
                        (click)="toggleMuteNotifications()"
                        [matTooltip]="ticket.is_muted?.email_enabled ?  'Notificaties staan aan' : 'Notificaties zijn gedempt'"
                        matTooltipPosition="below"
                        matTooltipTouchGestures="off">
                    <i class="fa-regular" [ngClass]="ticket.is_muted?.email_enabled ? 'fa-bell' : 'fa-bell-slash'"></i>
                </button>
                @if (canDeleteTicket()) {
                    <button mat-icon-button type="button" [matMenuTriggerFor]="ticketMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #ticketMenu="matMenu">
                        <button mat-menu-item type="button" (click)="deleteTicket()">
                            <mat-icon>delete</mat-icon>
                            <span>Verwijderen</span>
                        </button>
                    </mat-menu>
                }
            </div>
        </header>

        <div class="ticket-comment">
            @if (!isEditingTicket) {
                <div>
                    <div class="field-label">Ticket opmerking</div>
                    <p class="field-value">{{ ticket.comment || 'Geen opmerking' }}</p>
                </div>
                @if (ticket.can_edit) {
                    <button mat-icon-button type="button" (click)="startEditingTicket()" matTooltip="Ticket bewerken">
                        <i class="fa-light fa-pen"></i>
                    </button>
                }
            } @else {
                <form [formGroup]="ticketForm" class="w-100">
                    <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Ticket opmerking</mat-label>
                        <textarea
                            matInput
                            formControlName="comment"
                            placeholder="Voeg een opmerking toe aan dit ticket..."
                            rows="3">
                        </textarea>
                        <mat-error *ngIf="ticketForm.get('comment')?.hasError('maxlength')">
                            Opmerking mag maximaal 1000 karakters bevatten
                        </mat-error>
                    </mat-form-field>
                </form>
            }
        </div>

        <div class="ticket-grid">
            <div class="ticket-info">
                <div class="field">
                    <div class="field-label">Aangemaakt door</div>
                    <div class="field-value">{{ ticket.user?.name || 'Onbekend' }}</div>
                </div>
                <div class="field">
                    <div class="field-label">Aangemaakt op</div>
                    <div class="field-value">{{ ticket.created_at | date : "EEE d MMM yyyy HH:mm" }}</div>
                </div>
                <div class="responsibles">
                    <div class="field">
                        <div class="field-label">Projectcoördinator</div>
                        <div class="field-value">{{ ticket.projectcoordinator?.name || 'Onbekend' }}</div>
                    </div>
                    @if (!ticket.workorder_id) {
                        <div class="field">
                            <div class="field-label">Tekenaar</div>
                            <div class="field-value">{{ ticket.drawer?.name || 'Onbekend' }}</div>
                        </div>
                    }
                </div>
            </div>

            @if (!isEditingTicket) {
                <div class="ticket-state">
                    <div class="field">
                        <div class="field-label">Status</div>
                        <div><span class="status-badge" [ngClass]="'status-' + ticket.status">{{ ticket.status | TtmTicketStatus }}</span></div>
                    </div>
                    <div class="field">
                        <div class="field-label">Toegewezen aan</div>
                        <div class="field-value">{{ ticket.assignee?.name || 'Niet toegewezen' }}</div>
                    </div>
                    <ng-container *ngTemplateOutlet="azureLink"></ng-container>
                </div>
            } @else {
                <form [formGroup]="ticketForm" class="ticket-state edit-fields">
                    <div class="field">
                        <div class="field-label">Status</div>
                        <ng-select class="p-0" appearance="outline" formControlName="status" bindLabel="name" bindValue="key" [items]="ticketStatuses" [clearable]="false"></ng-select>
                    </div>
                    <div class="field">
                        <div class="field-label">Toegewezen aan</div>
                        <ng-select class="p-0" appearance="outline" formControlName="assignee_id" placeholder="Niet toegewezen" bindLabel="name" bindValue="id" [items]="users" [clearable]="true"></ng-select>
                    </div>
                    @if (Roles.Codalt | hasRole) {
                        <div class="field">
                            <div class="field-label">Afdeling</div>
                            <ng-select class="p-0" appearance="outline" formControlName="department" [placeholder]="null | TtmTicketDepartment" bindLabel="name" bindValue="key" [items]="departmentOptions" [clearable]="true"></ng-select>
                        </div>
                        <div class="field">
                            <div class="field-label">Azure DevOps-item</div>
                            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <input matInput type="text" inputmode="numeric" formControlName="azure_work_item_id" placeholder="Niet gekoppeld">
                            </mat-form-field>
                        </div>
                    } @else {
                        <ng-container *ngTemplateOutlet="azureLink"></ng-container>
                    }
                    <div class="edit-buttons">
                        <button mat-stroked-button type="button" (click)="cancelEditingTicket()">Annuleren</button>
                        <button mat-flat-button color="primary" type="button" [disabled]="ticketForm.invalid" (click)="saveTicket()">Opslaan</button>
                    </div>
                </form>
            }

            <ng-template #azureLink>
                <div class="field">
                    <div class="field-label">Azure DevOps</div>
                    <div class="field-value">
                        @if (ticket.azure_work_item_id) {
                            <a [href]="env.azureWorkItemUrl + ticket.azure_work_item_id" target="_blank" rel="noopener">#{{ ticket.azure_work_item_id }}</a>
                        } @else {
                            Niet gekoppeld
                        }
                    </div>
                </div>
            </ng-template>
        </div>
    </section>

    <div class="detail-columns">
        @if (ticket.ttm) {
            <section class="detail-card">
                <header class="card-header">
                    <div>
                        <h2 class="card-title">TVM #{{ ticket.ttm.id }}</h2>
                        <div class="card-subtitle">{{ $any(ticket.ttm).project?.name }}</div>
                    </div>
                    <div class="card-actions">
                        <a mat-stroked-button
                           routerLink="/{{Routenames.Projects}}/{{ticket.ttm.project_id}}"
                           [queryParams]="{ttm: ticket.ttm_id, drawing: ticket.ttm.entities[0]?.drawings[0]?.id, ticket: ticket.id}">
                            <i class="fa-regular fa-arrow-up-right-from-square"></i>
                            Openen op kaart
                        </a>
                        <span class="ttm-chip">{{ (ttmTypes | byKey : ticket.ttm.type_key)?.name }}</span>
                        @if (ttmStatuses | byKey : ticket.ttm.status_key; as ttmStatus) {
                            <span class="ttm-chip" [style.background-color]="'#' + ttmStatus.color" [style.color]="ttmStatus.textColor">
                                {{ ttmStatus.name }}
                            </span>
                        }
                    </div>
                </header>

                <div class="entity-table">
                    <div class="entity-row entity-head">
                        <span>Code</span>
                        <span>Naam</span>
                        <span>Coördinaten</span>
                        <span>Borden / maatregelen</span>
                    </div>
                    @for (entity of ticket.ttm.entities; track entity.id) {
                        <div class="entity-row">
                            <span class="entity-code">{{ entity.handle }}</span>
                            <span class="entity-name">{{ entity.name }}</span>
                            <a class="entity-coordinates" href="https://maps.google.com/?q={{ entity.gnd.coordinates[0][1] }},{{ entity.gnd.coordinates[0][0] }}" target="_blank" rel="noopener">
                                {{ entity.gnd.coordinates[0][1] | number : "0.0-3" }}, {{ entity.gnd.coordinates[0][0] | number : "0.0-3" }}
                            </a>
                            <div class="entity-images">
                                <div class="ttm-image" app-svg-as-img [svg]="entity?.plain_image?.svg"></div>
                                <div class="ttm-image" app-svg-as-img [svg]="entity?.projected_image?.svg"></div>
                                @if (entity?.gnd_image?.svg) {
                                    <div class="ttm-image" app-svg-as-img [svg]="entity?.gnd_image?.svg"></div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </section>
        } @else if (ticket.workorder) {
            <section class="detail-card">
                <header class="card-header">
                    <h2 class="card-title">Werkopdracht {{ ticket.workorder.id_4ps ?? ticket.workorder.source_no }}</h2>
                    <div class="card-actions">
                        <button mat-stroked-button type="button" (click)="openWorkorder(ticket.workorder_id)">
                            <i class="fa-regular fa-arrow-up-right-from-square"></i>
                            Openen
                        </button>
                    </div>
                </header>
                @if (ticket.workorder.description) {
                    <p class="mb-0">{{ ticket.workorder.description }}</p>
                }
            </section>
        }

        <section class="detail-card">
            <header class="card-header">
                <h2 class="card-title">Opmerkingen</h2>
            </header>
            <form [formGroup]="commentForm" #commentFormDirective="ngForm" (ngSubmit)="onSubmitComment(commentFormDirective)" class="comment-form">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <textarea
                        matInput
                        formControlName="text"
                        placeholder="Nieuwe opmerking"
                        rows="2"
                        [errorStateMatcher]="noErrorState"
                        (keydown.control.enter)="onSubmitComment(commentFormDirective)">

                    </textarea>
                    <button matSuffix mat-icon-button type="submit" class="comment-submit" [disabled]="commentForm.invalid" matTooltip="Opmerking toevoegen" aria-label="Opmerking toevoegen">
                        <i class="fa-regular fa-paper-plane-top"></i>
                    </button>
                </mat-form-field>
            </form>
            @if (sortedComments().length) {
                <ol class="comment-timeline">
                    @for (comment of sortedComments(); track comment.id) {
                        <li class="comment">
                            <span class="avatar" [ngClass]="'avatar-' + comment.avatarColor">{{ comment.initials }}</span>
                            <span class="comment-author">{{ comment.user?.name }}</span>
                            <p class="comment-text">{{ comment.comment }}</p>
                            <span class="comment-date">{{ comment.created_at | date : "EEE d MMM yyyy HH:mm" }}</span>
                            @if (comment.user?.id === currentUser?.id) {
                                <button mat-icon-button type="button" class="comment-delete" (click)="deleteComment(comment)" matTooltip="Opmerking verwijderen">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            }
                        </li>
                    }
                </ol>
            } @else {
                <p class="no-comments">Nog geen opmerkingen.</p>
            }

        </section>
    </div>
    }
</div>
